import React from 'react';

import QR from 'qrcode.react';
import { connect } from 'react-redux';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import PairSuccess from '../components/PairSuccess';
import AppDownload from '../components/AppDownload';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import {
  fetchFeaturedPlaylist,
  fetchHomePlaylist,
  fetchActivePlaylist,
  fetchMyPlaylist,
} from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { set4kQuality, setMute, setQR, setShowArtworkDetails, setSwitchArtwork, setShowLogo } from '../store/actions/settingActions';
import { BACK, ENTER, LEFT, RIGHT } from '../util/remoteButtons';
import { fireAnalytics } from './utils';

export class Pair extends React.Component {
  constructor(props) {
    super(props);
    // this.selectedBtn = 'android';
    this.android = React.createRef();
    this.ios = React.createRef();

    this.state = {
      openDownloadApp: false,
      openSuccess: false,
      selectedBtn: 'android',
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.closeAppDownload = this.closeAppDownload.bind(this);
  }

  async componentDidMount() {
    fireAnalytics('Page', 'Pair Page Loaded');
    let pairInterval = null;

    let PID = localStorage.getItem('playlistID');
    if (PID === null) PID = 'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx';
    const pair = async () => {
      try {
        const deviceResult = await this.props.fetchDevice(this.props.app.SCAPDeviceId);
        if (deviceResult.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        // console.log("Result : ", deviceResult);
        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          this.props.updateQuality(deviceResult.payload.highQuality);
          this.props.updateMute(deviceResult.payload.mute);
          this.props.updateQR(deviceResult.payload.qr);
          this.props.updateShowLogo(deviceResult.payload.logo);
          this.props.updateShowArtDetails(deviceResult.payload.details);
          clearInterval(pairInterval);
          const emailId = deviceResult.payload.email;
          const userId = deviceResult.payload.userId;
          fireAnalytics('Pair', 'App Paired', emailId);
          await this.props.mobileDeviceId(userId);
          // TODO: Move this into a redux action. Functionality is duplicated on the splash page.
          // if (!bdAuth.getToken()) {
          const response = await bdReq.post('/emailLogin', { emailId });
          if (response.success) {
            bdAuth._storeToken(response.body);
          }
          // }

          const fetchUser = await this.props.fetchUser();
          if (fetchUser.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchSubscription = await this.props.fetchSubscription();
          if (fetchSubscription.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
          if (fetchFeaturedPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchMyPlaylist = await this.props.fetchMyPlaylist();
          if (fetchMyPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchHomePlaylist = await this.props.fetchHomePlaylist();
          if (fetchHomePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchActivePlaylist = await this.props.fetchActivePlaylist(
            'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx'
          );
          if (fetchActivePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push(`/error`);
            }, 10);
            return;
          }
          clearInterval(this.onlineStatusInterval);
          this.setState({
            openSuccess: true,
          });

          setTimeout(() => {
            this.props.history.push('/playlist/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
          }, 2000);
        }
      } catch (e) {
        // console.log(e);
      }
    };

    pairInterval = setInterval(() => pair(), 3000);

    // setTimeout(() => {
    this.android.current.focus();
    // }, 1000);

    return () => {
      clearInterval(pairInterval);
    };
  }

  handleKeyDown(e) {
    e.stopPropagation();
    switch (e.which) {
      case RIGHT:
        if (this.state.selectedBtn === 'android') {
          this.ios.current.focus();
          this.setState({
            selectedBtn: 'ios',
          });
        }
        break;
      case LEFT:
        if (this.state.selectedBtn === 'ios') {
          this.android.current.focus();
          this.setState({
            selectedBtn: 'android',
          });
        }
        break;
      case ENTER:
        this.android.current.blur();
        this.ios.current.blur();
        this.setState({
          openDownloadApp: true,
        });

        break;
      case 27: /////////////////For Esc Keyboard Key
      case BACK:
        break;
    }
  }

  closeAppDownload() {
    this.setState({
      openDownloadApp: false,
    });
    if (this.state.selectedBtn === 'android') this.android.current.focus();
    else this.ios.current.focus();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.openSuccess && <PairSuccess />}
        {this.state.openDownloadApp && (
          <AppDownload
            selectedBtn={this.state.selectedBtn}
            closeAppDownload={this.closeAppDownload}
            props={this.props}
          />
        )}

        <div className="pair">
          <div
            className="pair__header"
            style={{
              height: window.innerWidth <= window.innerHeight ? '6vh' : '10vh',
            }}
          >
            <img
              className="pair__header__logo"
              src="assets/img/blackdove-logo-2020.png"
              alt=""
              style={{
                height: window.innerWidth <= window.innerHeight ? '35px' : '31px',
              }}
            />
            <p className="pair__header__text">digital canvas</p>
          </div>

          <p className="pair__quickStart" style={{ marginTop: window.innerWidth <= window.innerHeight ? '10%' : '6vh' }}>
            Quick Start Guide
          </p>

          <div
            style={{
              display: 'flex',
              flexDirection: window.innerWidth <= window.innerHeight ? 'column' : 'row',
              // margin: window.innerWidth > window.innerHeight && 'auto',
            }}
          >
            <div
              className="pair__box"
              style={{
                width: window.innerWidth <= window.innerHeight ? '78%' : '31%',
              }}
            >
              <div
                className="pair__box__textbox"
                style={{
                  fontSize: window.innerWidth <= window.innerHeight ? '3vw' : '1.2vw',
                }}
              >
                <p
                  className="pair__box__textbox__no"
                  style={{ width: window.innerWidth <= window.innerHeight ? '10%' : '15%' }}
                >
                  1
                </p>
                <p className="pair__box__textbox__text">Download and sign up on the Blackdove app</p>
              </div>
              <p className="pair__box__text">
                Blackdove’s mobile app is the management tool for browsing new artwork, building collections and
                selecting works for display on your Digital Canvas.
              </p>
              <div className="pair__box__btns">
                <button
                  className="pair__box__btns__androidIos"
                  style={this.state.selectedBtn === 'android' ? { border: '4px solid #910048' } : null}
                  ref={this.android}
                  onKeyDown={this.handleKeyDown}
                >
                  <div className="pair__box__btns__androidIos__icon">
                    <img className="" src="assets/img/android-icon.svg" alt=""></img>
                  </div>
                  <div
                    className="pair__box__btns__androidIos__text"
                    style={{
                      // fontSize: window.innerWidth <= window.innerHeight ? '1.2vw' : '1vw',
                    }}
                  >
                    Get the android app
                  </div>
                </button>
                <button
                  className="pair__box__btns__androidIos"
                  style={this.state.selectedBtn === 'ios' ? { border: '6px solid #910048' } : null}
                  ref={this.ios}
                  onKeyDown={this.handleKeyDown}
                >
                  <div className="pair__box__btns__androidIos__icon">
                    <img className="" src="assets/img/ios-icon.svg" alt=""></img>
                  </div>
                  <div
                    className="pair__box__btns__androidIos__text"
                    style={{
                      // fontSize: window.innerWidth <= window.innerHeight ? '1.2vw' : '1vw',
                    }}
                  >
                    Get the ios app
                  </div>
                </button>
              </div>
            </div>

            <div
              className="pair__box"
              style={{
                backgroundColor: '#222',
                marginTop: '1vh',
                width: '100%',
                padding: window.innerWidth <= window.innerHeight ? '60px 11%' : '4vh 2%',
                width: window.innerWidth <= window.innerHeight ? '100%' : '33%',
              }}
            >
              <div
                className="pair__box__textbox"
                style={{
                  fontSize: window.innerWidth <= window.innerHeight ? '3vw' : '1.2vw',
                }}
              >
                <p
                  className="pair__box__textbox__no"
                  style={{ width: window.innerWidth <= window.innerHeight ? '10%' : '15%' }}
                >
                  2
                </p>
                <p className="pair__box__textbox__text">Pair your display using the Blackdove app on your mobile</p>
              </div>
              <div className="pair__box__container">
                <div className="pair__box__container__instructions">
                  <p>
                    1. Tap the icon <img style={{ margin: '-4px 5px' }} src="assets/img/tv-icon.svg" alt="" /> in the
                    app
                  </p>
                  <p>2. Add a new display</p>
                  <p>3. Scan the QR code on the left</p>
                </div>
                <div className="pair__box__container__qrcode">
                  <QR
                    className=""
                    value={this.props.app.SCAPDeviceId}
                    size={window.innerWidth <= window.innerHeight ? '12vh' : '20vh'}
                    renderAs="svg"
                  />
                  <img className="pair__box__container__qrcode__logo" src="assets/img/red-logo.svg" alt="" />
                </div>
              </div>
            </div>

            <div
              className="pair__box"
              style={{
                width: window.innerWidth <= window.innerHeight ? '78%' : '31%',
              }}
            >
              <div
                className="pair__box__textbox"
                style={{
                  fontSize: window.innerWidth <= window.innerHeight ? '3vw' : '1.2vw',
                }}
              >
                <p
                  className="pair__box__textbox__no"
                  style={{ width: window.innerWidth <= window.innerHeight ? '10%' : '15%' }}
                >
                  3
                </p>
                <p className="pair__box__textbox__text">It’s time to play art</p>
              </div>
              <p className="pair__box__text">
                From within your Blackdove app, select an artwork and press{' '}
                <img style={{ margin: '-7px 5px' }} src="assets/img/play-icon.svg" alt="" />
              </p>
            </div>
          </div>
          <div
            className="pair__footer"
            style={{
              height: window.innerWidth <= window.innerHeight ? '12vh' : '10vh',
              // fontSize: window.innerWidth <= window.innerHeight ? '1.5vw' : '1.2vw',
            }}
          >
            For help contact: <strong>support@blackdove.com</strong>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app,
  };
}, mapDispatchToProps)(Pair);
